import React from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { HumAInSection } from './components/HumAInSection';
import { VerticalsSection } from './components/VerticalsSection';
import { FeaturesSection } from './components/FeaturesSection';
import { DashboardsPreviewSection } from './components/DashboardsPreviewSection';
import { CTASection } from './components/CTASection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-white w-full" data-id="element-0">
      <Header data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <HumAInSection data-id="element-4" />
        <VerticalsSection data-id="element-5" />
        <DashboardsPreviewSection data-id="element-6" />
        <FeaturesSection data-id="element-7" />
        <CTASection data-id="element-8" />
      </main>
      <Footer data-id="element-9" />
    </div>;
}